 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"31c61c99efb112099ae0f1f35955197d62564336","1":"c2793f15b5e92e552f3039b03c5bdd47bd7f3ac3","2":"ef83a63a1cc16cbe0b48a84e5cdd981052b98b77","3":"f673898f9dd6774d11285a552f9128c51c54d616","4":"9f12ea78a1051811df3fd20aa004934bf6a8a530","5":"component---src-templates-product-tsx","8":"component---src-pages-cart-tsx","9":"component---src-pages-docs-tsx","10":"component---src-pages-previews-tsx","11":"component---src-templates-404-tsx","12":"component---src-templates-article-index-tsx","13":"component---src-templates-article-tsx","14":"component---src-templates-collection-tsx","15":"component---src-templates-page-tsx","16":"component---src-templates-spices-tsx","19":"src-components-about-aboutAnything","20":"src-components-about-aboutFreshness","21":"src-components-about-aboutImageAndText","22":"src-components-about-enlightenment","23":"src-components-about-textImageArray","24":"src-components-global-badgesHero","25":"src-components-global-ctaBlock","26":"src-components-global-deck","27":"src-components-global-doubleCta","28":"src-components-global-faqs","29":"src-components-global-imageAndText","30":"src-components-global-marketingImageText","31":"src-components-global-marquee","32":"src-components-global-nestedProductHero","33":"src-components-global-pressModule","34":"src-components-global-productCarousel","35":"src-components-global-productRow","36":"src-components-global-productScroll","37":"src-components-global-reduceWaste","38":"src-components-global-shopAllCardsMarquee","39":"src-components-global-shoppableHero","40":"src-components-global-textBlock","41":"src-components-global-twoPodColumns"}[chunkId]||chunkId) + "-" + {"0":"8d318136e04f31c52b20","1":"f4f2587772a709ec5b5d","2":"f48de0ed5d7d20ae48a3","3":"441df5c63844c9f258c0","4":"67964f955884d7415ceb","5":"7872f3e7a24c79be5046","8":"dc61be4212e6e8fc151f","9":"c0f1e02fbb0267ed38a6","10":"8ba41d44c76a8a57184c","11":"0e87be54c515b1c3bd5b","12":"361a2fd278f7b895064d","13":"af276303447e198f9b6f","14":"040e4b31211744eb71e5","15":"defae3daac8e1291a18a","16":"c688b59d6072e29b7c97","19":"98d5ef67fe0f111b5d94","20":"b98d744768de7a4c0904","21":"d195a8d5762d6d55e463","22":"af6efb9cd10d8c11f5eb","23":"078a6fe36ee3909005cd","24":"9793a2e1a96881a311a1","25":"a15940b98bedcfb937a5","26":"9b74f91f45761d2c1069","27":"214316cc2bde89f880f1","28":"b150893e9e58f40f613a","29":"34cd0997cfd5a642a2bb","30":"398dd94b428cba500b40","31":"0e187429fec93fa18683","32":"b6d69064209632d14bcb","33":"2c00781ac56b3a8624f2","34":"73446c66eac4621a28cf","35":"9b233444fd587c96c752","36":"33ca1a1da49e1a1cbab1","37":"e1828dcf66011c311948","38":"bbd8cc49bd5fe3ae8995","39":"92bb6113fc82b81d118e","40":"a430b8697cb836c885b5","41":"496fddb4b81ec89c3947"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
